import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const StuckPayments = lazy(() => import('../../pages/StuckPayments/StuckPaymentsPage'));

function PagesRoute() {
  return (
    <Routes>
      <Route path="/*" element={<StuckPayments />} />
    </Routes>
  );
}

export default PagesRoute;
